import { render } from "./AdicionarProduto.vue?vue&type=template&id=20c10c1a"
import script from "./AdicionarProduto.vue?vue&type=script&lang=js"
export * from "./AdicionarProduto.vue?vue&type=script&lang=js"
script.render = render

export default script